<template>
  <h1>{{ message }}</h1>
</template>

<script>
export default {
  name: 'questionnairesList',
  data: function () {
    return {
      action: '/questionnaires/list',
      message: 'Hello Questionnaires!'
    }
  }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/questionnaires/list.vue